<template>
  <div v-if="modal">
    <div class="modal-background" />
    <transition name="slide-inside">
      <div class="modal-wrapper" v-if="showContent">
        <div class="modal-title">
          <span>{{ modal.title }}</span>
          <a v-if="modal.link" :href="modal.link" target="_blank">
            <div class="question-mark" />
          </a>
        </div>
        <div
          v-for="text in modal.content"
          :key="text"
          class="modal-text-content"
        >
          {{ text }}
        </div>
        <div v-if="modal.isInput" class="modal-input-container">
          <input
            ref="inp"
            @focus="clearStyle"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            type="text"
            :class="['modal-input', { 'invalid-input': isInvalid }]"
          />
        </div>
        <div class="modal-btn-container">
          <div
            class="modal-btn btn-confirm"
            v-if="modal.btnConfirm"
            @click="confirm"
          >
            {{ modal.btnConfirm }}
          </div>
          <div
            class="modal-btn btn-cancel"
            v-if="modal.btnCancel"
            @click="hide(true)"
          >
            {{ modal.btnCancel }}
          </div>
        </div>
        <div class="env-close btn-close" @click="hide" />
        <div v-if="modal.noShow" class="modal-noshow-button">
          <label>
            <check-box
              class="noshow-checkbox"
              :checked="isNoshowAgain"
              @change="updateNoshow"
            />
            <span class="noshow-label">{{ $t('DIALOG.str61') }}</span>
          </label>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import CheckBox from '@/components/common/CheckBox';
import { Modal } from '@/js/plugin';
import { EventBus, getBit, setBit, isStr, isFunction } from '@/js/utils';
export default {
  name: 'Modal',
  components: {
    CheckBox,
  },
  data() {
    return {
      modalList: [],
      showContent: false,
      isInvalid: false,
      isNoshowAgain: false,
      inputValue: '',
    };
  },
  computed: {
    modal() {
      return this.modalList[this.modalList.length - 1];
    },
    userPreferences() {
      return this.$store.getters['user/userPreferences'];
    },
  },
  methods: {
    updateNoshow(notShow) {
      this.isNoshowAgain = notShow;
    },
    hide(isCanceled) {
      if (isCanceled === true) {
        if (isFunction(this.modal.onCancel)) {
          this.modal.onCancel();
        }
        if (this.isNoshowAgain) {
          EventBus.$emit('set-userinfo', {
            user_preferences: setBit(this.userPreferences, this.modal.noShow),
          });
        }
      }
      this.modalList.pop();
      this.isNoshowAgain = false;
      // this.showContent = false;
      // this.isInvalid = false;
    },
    confirm() {
      if (isFunction(this.modal.onConfirm)) {
        let data;
        if (this.modal.isInput) {
          data = this.$refs.inp.value;
          if (isFunction(this.modal.inputValidation)) {
            if (!this.modal.inputValidation(data)) {
              this.isInvalid = true;
              return;
            }
          }
        }
        this.modal.onConfirm(data);
        if (this.isNoshowAgain) {
          EventBus.$emit('set-userinfo', {
            user_preferences: setBit(this.userPreferences, this.modal.noShow),
          });
        }
        this.hide();
      } else {
        this.hide();
      }
    },
    show(params) {
      this.showContent = false;
      this.isInvalid = false;
      const modalParams = {
        title: params.title,
        content: isStr(params.content) ? [params.content] : params.content,
        isInput: params.isInput,
        link: params.link,
        btnCancel: params.btnCancel,
        btnConfirm: params.btnConfirm,
        onConfirm: params.onConfirm,
        onCancel: params.onCancel,
        inputValidation: params.inputValidation,
        noShow: params.noShow,
        defaultValue: params.defaultValue || '',
      };
      if (
        modalParams.noShow &&
        getBit(this.userPreferences, modalParams.noShow)
      ) {
        if (isFunction(params.onConfirm)) params.onConfirm();
      } else {
        this.modalList.push(modalParams);
        this.$nextTick().then(() => {
          this.showContent = true;
          this.$nextTick().then(() => {
            if (modalParams.isInput) {
              this.$refs.inp.focus();
              this.$refs.inp.value = modalParams.defaultValue;
            }
          });
        });
      }
    },
    clearStyle() {
      this.isInvalid = false;
    },
    openDocument(link) {
      open(link, 'documentation');
    },
  },
  beforeMount() {
    Modal.EventBus.$on('show', this.show);
    window.onkeydown = (event) => {
      if (event.keyCode === 13 && this.modal) {
        this.confirm();
      }
    };
  },
  beforeDestroy() {
    Modal.EventBus.$off();
    window.onkeydown = null;
  },
};
</script>

<style scoped>
.modal-wrapper {
  z-index: 10001;
  position: fixed;
  top: 50%;
  left: 50%;
  width: 80%;
  transform: translate(-50%, -50%);
  padding: 25px 20px 20px;
  max-width: 420px;
  min-width: 250px;
  border-radius: 5px;
  overflow: hidden;
  font-size: 1.1em;
  line-height: 1.6;
  word-break: break-word;
  background-color: #ffffff;
  cursor: default;
  box-shadow: 0 7px 8px -2px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.modal-title {
  font-size: 1.25em;
  font-weight: bold;
  margin: 5px 0 15px 0;
}

.modal-title > * {
  vertical-align: bottom;
}

.modal-btn-container {
  padding-top: 10px;
  text-align: center;
}

.btn-confirm {
  color: #fff;
  background-color: #ed7e57;
  border: 1px solid #ed7e57;
}

.btn-confirm:hover {
  background-color: #e74a1f;
}

.btn-cancel {
  color: #898989;
  border: 1px solid #898989;
}

.btn-cancel:hover {
  background-color: #898989;
  color: #f2f2f2;
}

.modal-btn {
  display: inline-block;
  margin: 10px 2%;
  padding: 5px 3%;
  text-align: center;
  border-radius: 20px;
  min-width: 30%;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}

.btn-close {
  position: absolute;
  width: 18px;
  height: 18px;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.modal-background {
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10000;
  overflow: auto;
}

.modal-text-content + .modal-text-content {
  margin-top: 5px;
}

.modal-input-container {
  text-align: center;
  margin: 10px 0;
  position: relative;
}

.modal-input {
  -webkit-appearance: none;
  appearance: none;
  border: none;
  outline: none;
  border-radius: 0;
  border-bottom: 1px solid #2f2f2f;
  font-size: 1.1em;
  width: 80%;
}

.modal-noshow-button {
  font-size: 0.9em;
  color: #898989;
  position: relative;
  margin-top: 5px;
  height: 1em;
}

.noshow-checkbox {
  font-size: 0.8em;
  margin: 0 0.2em 0.2em;
}

.noshow-label {
  cursor: pointer;
}

.invalid-input {
  box-shadow: 0 0 2px 4px rgba(255, 0, 0, 0.4);
}

.slide-inside-enter,
.slide-inside-leave-to {
  top: 25%;
  opacity: 0;
}

.slide-inside-enter-active,
.slide-inside-leave-active {
  transition: 0.2s ease-out;
}
</style>
